import { useLocation } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'

export function useAdminView() {
  const location = useLocation()
  const { isAdmin } = useUser()

  const isAdminView = location.pathname.startsWith('/admin')

  return {
    isAdminView,
    isAdmin,
    canAccessAdmin: isAdmin,
  }
}
